
import VuerSingle from './VuerSingle'
import To from './to.js'
import Icon from 'vux/src/components/icon/index.vue'


export default {
components: { VuerSingle, Icon },
data () {
return {
imgList: [],
isSingle: false,
isShow: false,
allowSwipe: false,
currentIndex: 0,
/* 从允许swipe开始纪录swipe位移
* handleTouchEnd时位移小于100（意味着无法触发swipe），清零
* 大于100必定触发handleSwipe，
* 修改currentIndex后清零
*/
swipeDelta: 0,
swipeThreshold: 100
}
},
beforeRouteLeave (to, from, next) {

this.isShow = false
next()
},
computed: {
maxIndex () {
return this.imgList.length - 1
}
},
watch: {
isShow (val) {
if (val) {

if (/android/i.test(navigator.userAgent)) {
history.pushState(null, null, location.href)
window.addEventListener('popstate', this.closeGallery)
}
document.querySelector('.prevent-pass-through').className =
'prevent-pass-through prevent-pass-through-show'
document.querySelector('.slider').className = 'slider open'
} else {
window.removeEventListener('popstate', this.closeGallery)
setTimeout(
() =>
(document.querySelector('.prevent-pass-through').className =
'prevent-pass-through'),
400
)
document.querySelector('.slider').className = 'slider close'
}
},
currentIndex () {

let el = document.querySelector('.item-wrapper')
el.translateX = -this.currentIndex * el.getBoundingClientRect().width
},
imgList () {
let el = document.querySelector('.item-wrapper')
el.translateX = -this.currentIndex * el.getBoundingClientRect().width
}
},
methods: {
handleTapClose () {
if (/android/i.test(navigator.userAgent)) {
history.back()
}
this.handleClose()
},
handleClose () {
this.closeGallery()
},
closeGallery () {
this.isShow = false
this.$refs.img[this.currentIndex].reset()
},
handlePressMove (e, el) {
e.preventDefault()
if (this.allowSwipe === false || this.isSingle) return
el.translateX += e.deltaX
this.swipeDelta += e.deltaX
},
handleTouchStart () {
To.stopAll()
},
handleTouchEnd (e, el) {

if (Math.abs(this.swipeDelta) < this.swipeThreshold) this.swipeDelta = 0
let width = el.getBoundingClientRect().width
/* eslint-disable no-new */
new To(el, 'translateX', -this.currentIndex * width, 200, this.ease)
},
handleSwipe (evt, el) {

if (Math.abs(this.swipeDelta) < this.swipeThreshold) {
this.swipeDelta = 0
return
}
let width = el.getBoundingClientRect().width
if (evt.direction === 'Left' && this.currentIndex < this.maxIndex) {
this.$refs.img[this.currentIndex].reset()
this.currentIndex += 1
} else if (evt.direction === 'Right' && this.currentIndex > 0) {
this.$refs.img[this.currentIndex].reset()
this.currentIndex -= 1
}
new To(el, 'translateX', -this.currentIndex * width, 200, this.ease)
this.swipeDelta = 0
},
savePicture () {
let url = this.imgList[this.currentIndex]
if (url) {
this.$vux.toast.text('請在新視窗中長按儲存圖片', 'bottom')
window.open(url, '_blank')
}
}
}
}
